export interface AddItemSubtitleProps {
  subtitle: string;
}

const AddItemSubtitle = ({ subtitle }: AddItemSubtitleProps) => (
  <div
    className="sticky bottom-0 z-[1] mt-auto border-t border-x-0 border-b-0 border-solid border-[#C3C6D4] bg-[#FFFFFF] px-4 py-4"
    role="complementary"
  >
    <span className="text-xs text-[#676879]" style={{ fontFamily: "Poppins" }}>
      {subtitle}
    </span>
  </div>
);

export default AddItemSubtitle;
